var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperclip = function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28 4.745a.85.85 0 0 1 1.22.035.905.905 0 0 1-.035 1.26L6.405 9a.785.785 0 0 0 0 1.15 1 1 0 0 0 1.335 0l4.14-4a2.5 2.5 0 0 0 0-3.595 2.8 2.8 0 0 0-3.855 0l-4.5 4.365a4.165 4.165 0 0 0 0 6.035 4.62 4.62 0 0 0 6.375 0l4.14-4a.85.85 0 0 1 1.225.035.91.91 0 0 1-.035 1.255l-4.14 4a6.32 6.32 0 0 1-8.75 0 6 6 0 0 1 0-8.62l4.5-4.365a4.5 4.5 0 0 1 6.23 0 4.295 4.295 0 0 1 0 6.18l-4.145 4a2.67 2.67 0 0 1-3.705 0 2.59 2.59 0 0 1 0-3.735z"
  })));
};
export default SvgPaperclip;